import { render, staticRenderFns } from "./point-style.vue?vue&type=template&id=b5860848"
import script from "./point-style.vue?vue&type=script&lang=js"
export * from "./point-style.vue?vue&type=script&lang=js"
import style0 from "./point-style.vue?vue&type=style&index=0&id=b5860848&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports